import React, { useState, useContext, useEffect } from "react";
import { useForm, Controller, set } from "react-hook-form";
import { checkStaffPassword } from "../../api/apiManagement";
import { StaffPortalContext } from "./StaffPortal";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  InputLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";

const StaffLoginPage = () => {
  const {
    register,
    handleSubmit,
    control,
    setError,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm({});

  const { setCurrentStep } = useContext(StaffPortalContext);

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (d) => {
    console.log(d);

    setIsLoading(true);
    checkStaffPassword({ password: d?.password })
      .then((res) => {
        console.log(res);
        const currentStatus = res.data.status;
        if (currentStatus === "200") {
          setCurrentStep(1);
        }
        if (currentStatus === "503") {
          setError("password");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}
      >
        Samsung Staff Only<br></br>只限員工使用
      </Typography>
      <Box
        sx={{
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <InputLabel htmlFor="password">
          <span className="label-container">
            <span className="red">*</span>
            Password
            <br></br>
            密碼
          </span>
        </InputLabel>
        <TextField
          fullWidth
          variant="standard"
          disabled={isLoading}
          type="password"
          {...register("password")}
        />
        {errors.password && (
          <FormHelperText error>Password invalid 密碼錯誤</FormHelperText>
        )}
      </Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <LoadingButton
          type="submit"
          variant="outlined"
          onClick={handleSubmit(onSubmit)}
          sx={{ borderRadius: "30px", lineHeight: "20px", width: "140px" }}
          disabled={isLoading}
        >
          Login<br></br> 登入
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default StaffLoginPage;
